import { toTitleCase } from "../../js/utils/titleCase";

export default function ModalBase({
  isOpen,
  title,
  onClose,
  children,
  wide = false,
  quiet = false,
  compact = false,
  welcome = false,
  hideClose = false,
  className = "",
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose} role="presentation">
      <div
        className={`modal-container${wide ? " modal-wide" : ""}${quiet ? " modal-quiet" : ""}${
          compact ? " modal-compact" : ""
        }${welcome ? " modal-welcome" : ""}${className ? ` ${className}` : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="modal-header">
          <h2 id="modal-title">{welcome ? title : toTitleCase(title)}</h2>
          {hideClose ? null : (
            <button type="button" onClick={onClose} className="modal-close" aria-label="Close">
              ×
            </button>
          )}
        </header>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}
